<div class="bg-white p-5">
  <!-- Approved memberships --->
  <h2 class="text-2xl font-bold mb-4 text-dc-navy">
    {{ "MEM.TITLE" | translate }}
  </h2>
  <div class="mb-4 mt-4 lg:w-[40%]">
    <app-validation-message
      [type]="'default'"
      [showCloseIcon]="false"
      [showTypeIcon]="true"
      [content]="{
        title: 'BG_DASH.SELECT_PRIMARY_TITLE',
        message: 'BG_DASH.PRIMARY_MEMBERSHIP_INFO',
      }"
      (onBtnClick)="(false)"
    ></app-validation-message>
  </div>

  <div class="flex gap-3 mb-6">
    <app-button
      classesName="btn-edge-cut"
      [label]="'MEM.APPLY_NEW' | translate"
      (onBtnClick)="applyNewMembership()"
    >
    </app-button>

    <app-button
      classesName="card-edge-cut-white"
      [label]="'MEM.JOIN_EXISTING' | translate"
      (onBtnClick)="joinExisting()"
    >
    </app-button>
  </div>

  @if (loadingAccounts) {
    <app-skeleton-loader
      [formLoader]="true"
      [noOfFields]="8"
    ></app-skeleton-loader>
  }
  <!--List of accounts/membership  -->
  @if (!loadingAccounts) {
    <div class="gap-6">
      @for (account of accountsList; track account) {
        <div class="border border-dc-navy p-5 relative mb-6">
          <h2
            class="text-dc-navy text-2xl font-semibold mb-2 cursor-pointer"
            (click)="viewMembership(account)"
          >
            {{
              lan == "en"
                ? account["DC Name English"]
                : account["DC Name Arabic"]
            }}
          </h2>
          <!-- chips -->
          <div class="flex gap-2 mb-4">
            @if (accountId === account.Id) {
              <span class="dc-status dc-status-info">
                {{ "BG_DASH.IS_PRIMARY" | translate }}
              </span>
            }
            <span
              class="dc-status"
              [ngClass]="{
                 'dc-status-cancelled':
                  getMemberDisplayStatus(account) === 'Inactive' ||
                  getMemberDisplayStatus(account) === 'Cancelled',
                'dc-status-negative': getMemberDisplayStatus(account) === 'Expired',
                'dc-status-warning':
                  getMemberDisplayStatus(account) === 'Active - Renew',
                'dc-status-active':
                  getMemberDisplayStatus(account) !== 'Expired' &&
                  getMemberDisplayStatus(account) !== 'Inactive' &&
                  getMemberDisplayStatus(account) !== 'Cancelled' &&
                  getMemberDisplayStatus(account) !== 'Active - Renew'
              }"
            >
              <!-- @if(isLicenseActive(account)) {
          {{ "MEM.LICENSE_ACTIVE" | translate }}
          } @else {
          {{ "MEM.LICENSE_EXPIRED" | translate }}
          } -->
              {{
                "ACCOUNT.LICENSE_ACTIVE"
                  | translate: { licenseStatus: getMemberDisplayStatus(account) }
              }}
            </span>
            @if (account.CSN) {
              <!-- Access request -->
              @if (
                account["DC Account Count BC_Member KPI MVL"][
                  "PendingSRCount"
                ] > 0
              ) {
                <span class="dc-status dc-status-inactive">
                  {{
                    "MEM.ACTION_REQUIRED"
                      | translate
                        : {
                            n: account["DC Account Count BC_Member KPI MVL"][
                              "PendingSRCount"
                            ],
                          }
                  }}
                </span>
              }

              <!-- Access request -->
              @if (
                account["DC Account Count BC_Member KPI MVL"][
                  "UserAccessSRCount"
                ] > 0 && isPrimaryUser(account["CSN"])
              ) {
                <span class="dc-status dc-status-inactive">
                  {{
                    "MEM.ACCESS_REQUEST"
                      | translate
                        : {
                            n: account["DC Account Count BC_Member KPI MVL"][
                              "UserAccessSRCount"
                            ],
                          }
                  }}
                </span>
              }
            }
          </div>

          <div class="w-[90%]">
            <div
              class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-4 text-dc-navy text-lg mb-4"
            >
              <div class="mb-1 text-dc-navy">
                {{ "MEM.NUM" | translate }}
                <div class="font-semibold">{{ account.CSN }}</div>
              </div>
              <div class="mb-1 text-dc-navy">
                {{ "MEM.LIC" | translate }}
                <div class="font-semibold">
                  {{ account["DC License Registration Number"] }}
                </div>
              </div>
              <div class="mb-1 text-dc-navy">
                {{ "MEM.EXP" | translate }}
                <div class="font-semibold">
                  {{ account?.["DC Expiry Date"] | date: "dd MMMM yyyy" }}
                </div>
              </div>

              <div class="mb-1">
                {{ "MEM.USERS" | translate }}
                <div class="font-semibold">
                  {{
                    account["DC Account Count BC_Member KPI MVL"][
                      "ActiveContactsCount"
                    ]
                  }}
                </div>
              </div>
            </div>

            <div
              class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-4 text-dc-navy text-lg mb-4"
            >
              <div class="mb-1 text-dc-navy">
                {{ "MEM.APPS" | translate }}
                <div class="font-semibold">
                  {{
                    account["DC Account Count BC_Member KPI MVL"][
                      "TotalSRCount"
                    ]
                  }}
                </div>
              </div>

              <div class="mb-2">
                {{ "MEM.PROFILE" | translate }}
                <div class="flex items-center gap-3">
                  <span class="font-semibold">
                    {{
                      "MEM.COMPLETE"
                        | translate
                          : {
                              number: account[
                                "DC Account Count BC_Member KPI MVL"
                              ]["MemberProfileComplete%"]
                                ? getNumberValue(
                                    account[
                                      "DC Account Count BC_Member KPI MVL"
                                    ]["MemberProfileComplete%"]
                                  )
                                : 0,
                            }
                    }}
                  </span>
                  <span class="h-2 flex-1 bg-gray-200 rounded overflow-hidden">
                    <span
                      class="block h-full bg-dc-dark-blue"
                      [style.width.%]="
                        account['DC Account Count BC_Member KPI MVL'][
                          'MemberProfileComplete%'
                        ]
                          ? account['DC Account Count BC_Member KPI MVL'][
                              'MemberProfileComplete%'
                            ]
                          : 0
                      "
                    ></span>
                  </span>
                </div>
              </div>
            </div>
            <!-- Actions -->
            <div class="flex flex-wrap gap-4 items-center mt-2">
              @if (accountId !== account.Id && ( account['Account Status'] != 'Inactive' &&
                                account['Account Status'] != 'Cancelled')) {
                <app-button
                  classesName="card-edge-cut-white"
                  [label]="'BUTTONS.SET_PRIMARY' | translate"
                  (onBtnClick)="setAsPrimaryAccount(account)"
                />
              }
              <!-- Only primary user can download the certificate and apply for mange signatory -->
              @if (isPrimaryUser(account["CSN"]) && ( account['Account Status'] != 'Inactive' &&
                                account['Account Status'] != 'Cancelled')) {
                  <app-button
                    classesName="card-edge-cut-white"
                    [label]="'BG_DASH.MANAGE_USERS' | translate"
                    (onBtnClick)="manageUsers(account)"
                  />
                
              }
              @if (account["DC Certificate URL"]) {
                <app-button
                  classesName="card-edge-cut-white"
                  [label]="'ACCOUNT.ACTIONS.CERTIFICATE' | translate"
                  (onBtnClick)="downloadCert(account)"
                />
              }
            </div>
          </div>
          <!-- corner edge decoration -->
          <span
            [ngClass]="
              account.CSN ? 'dc-card-corner-blue' : 'dc-card-corner-red'
            "
          ></span>
        </div>
      }
    </div>
  }
</div>

<!-- Pending approval --->
<div class="bg-white p-5 mt-4">
  @if (pendingRequests.length > 0) {
    <h2 class="text-2xl font-bold my-6 text-dc-navy">
      {{ "MEM.PENDING" | translate }}
    </h2>
    <div class="">
      @for (request of pendingRequests; track request) {
        <div class="border border-dc-navy p-5 relative mb-6">
          <h2 class="text-dc-navy text-2xl font-semibold mb-2">
            {{
              lan == "en"
                ? request["DC Member Name (English)"]
                : request["DC Member Name (English)"]
            }}
          </h2>
          <div class="w-[90%]">
            <div
              class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-4 text-dc-navy text-lg mb-4"
            >
              <div class="mb-1 text-dc-navy">
                {{ "MEM.NUM" | translate }}
                <div class="font-semibold">
                  {{ request.CSN ? request.CSN : "-" }}
                </div>
              </div>
              <div class="mb-1 text-dc-navy">
                {{ "MEM.LIC" | translate }}
                <div class="font-semibold">
                  {{
                    request["DC License Registration Num Member Level"]
                      ? request["DC License Registration Num Member Level"]
                      : "-"
                  }}
                </div>
              </div>
            </div>
          </div>

          <!-- Actions -->
          <div class="flex gap-3 mb-6">
            <app-button
              classesName="card-edge-cut-white"
              [label]="'BUTTONS.REVOKE' | translate"
              (onBtnClick)="revokeRequest(request)"
            >
            </app-button>
          </div>
          <span class="dc-card-corner-blue"></span>
        </div>
      }
    </div>
  }
  <!-- paltinum card info -->
  <!-- <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-5">
    <div class="space-y-4">
      <app-validation-message
        [type]="'default'"
        [content]="{
          title: 'MEM.PLAT_TITLE' | translate,
          message: 'MEM.PLAT_BODY' | translate,
        }"
        [showbutton]="false"
        [buttonText]="'BUTTONS.VIEW_DETAILS' | translate"
        (onBtnClick)="gotoBenfits()"
      ></app-validation-message>
    </div>
  </div> -->
</div>

